<template>
  <div class="contact-support">
    <!-- Page Header -->
    <div class="contact-support-header">
      <div class="contact-support-header-bg"></div>
      <div class="contact-support-header-content">
        <h1>Contact Support</h1>
        <p>We’re here to help!</p>
      </div>
    </div>

    <div class="contact-support-body">
      <div class="contact-support-intro">
        Fill out the form below and our support team will get back to you within 24–48 hours.
      </div>
      <el-form
        ref="contactForm"
        :model="form"
        :rules="rules"
        class="contact-support-form"
      >
        <div class="contact-support-row">
          <el-form-item prop="firstName" class="form-item-half">
            <el-input v-model="form.firstName" placeholder="First Name"></el-input>
          </el-form-item>
          <el-form-item prop="lastName" class="form-item-half">
            <el-input v-model="form.lastName" placeholder="Last Name"></el-input>
          </el-form-item>
        </div>
        <el-form-item prop="email">
          <el-input v-model="form.email" placeholder="Email Address"></el-input>
        </el-form-item>
        <el-form-item prop="phone">
          <el-input v-model="form.phone" placeholder="Phone Number"></el-input>
        </el-form-item>
        <el-form-item prop="subject">
          <el-input v-model="form.subject" placeholder="Subject"></el-input>
        </el-form-item>
        <el-form-item prop="message">
          <el-input v-model="form.message" type="textarea" :rows="5" placeholder="How can we help you?"></el-input>
        </el-form-item>
        <el-button type="primary" class="contact-support-submit" :loading="submitting" @click="submit">
          Send Message
        </el-button>
      </el-form>
    </div>
  </div>
</template>

<script>
import * as contactMessagesAPI from '@/api/contact-messages'
export default {
  name: 'ContactSupport',
  data() {
    return {
      submitting: false,
      form: {
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        subject: '',
        message: ''
      },
      rules: {
        email: [
          { required: true, message: 'Email is required', trigger: 'blur' },
          { type: 'email', message: 'Please enter a valid email', trigger: 'blur' }
        ],
        message: [{ required: true, message: 'Message is required', trigger: 'blur' }],
        firstName: [{ max: 100, message: 'Max 100 characters', trigger: 'blur' }],
        lastName: [{ max: 100, message: 'Max 100 characters', trigger: 'blur' }],
        phone: [{ max: 50, message: 'Max 50 characters', trigger: 'blur' }],
        subject: [{ max: 255, message: 'Max 255 characters', trigger: 'blur' }]
      }
    }
  },
  methods: {
    submit() {
      if (this.submitting) {
        return
      }
      this.$refs.contactForm.validate(valid => {
        if (!valid) {
          return
        }
        this.submitting = true
        contactMessagesAPI
          .postContactMessage(this.form)
          .then(res => {
            if (res.status === 200) {
              this.notifySucceed('Message sent successfully')
              this.$refs.contactForm.resetFields()
            } else {
              this.notifyError('Failed to send message', res.msg)
            }
          })
          .catch(err => {
            this.notifyError('Failed to send message', err)
          })
          .finally(() => {
            this.submitting = false
          })
      })
    }
  }
}
</script>

<style scoped>
.contact-support {
  background: #F4F5F7;
  min-height: 100vh;
}

/* Page Header */
.contact-support-header {
  position: relative;
  height: 280px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.contact-support-header-bg {
  position: absolute;
  inset: 0;
  background: linear-gradient(135deg, #14213D 0%, #0F1930 50%, #C9A227 100%);
}
.contact-support-header-bg::after {
  content: '';
  position: absolute;
  inset: 0;
  background: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.05'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
}
.contact-support-header-content {
  position: relative;
  z-index: 1;
  text-align: center;
  padding: 0 20px;
}
.contact-support-header-content h1 {
  font-size: 42px;
  font-weight: 800;
  color: #ffffff;
  margin-bottom: 12px;
  text-transform: uppercase;
  letter-spacing: 2px;
}
.contact-support-header-content p {
  font-size: 18px;
  color: rgba(255,255,255,0.9);
}

/* Body */
.contact-support-body {
  max-width: 600px;
  margin: 0 auto;
  padding: 50px 24px 80px;
}
.contact-support-intro {
  text-align: center;
  font-size: 15px;
  color: #666666;
  margin-bottom: 30px;
  line-height: 1.7;
}
.contact-support-form {
  background: #ffffff;
  padding: 32px;
  border-radius: 16px;
  box-shadow: 0 18px 40px rgba(20, 33, 61, 0.08);
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.contact-support-row {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
}
.form-item-half {
  margin-bottom: 0;
}
.contact-support-submit {
  width: 100%;
  background: linear-gradient(135deg, #14213D 0%, #0F1930 100%);
  border-color: #0F1930;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-weight: 600;
  padding: 14px 0;
  margin-top: 8px;
}
.contact-support-submit:hover {
  background: #0F1930;
  border-color: #0F1930;
}

@media (max-width: 720px) {
  .contact-support-header {
    height: 200px;
  }
  .contact-support-header-content h1 {
    font-size: 28px;
  }
  .contact-support-body {
    padding: 30px 12px 60px;
  }
  .contact-support-form {
    padding: 24px;
    border-radius: 12px;
  }
  .contact-support-row {
    grid-template-columns: 1fr;
    gap: 0;
  }
}
</style>
